module.exports = __webpack_public_path__ + "img/calendar_black.b16dceaf.svg";